import styled from "styled-components";
import { API_CALLS } from "../../../../../../../API/api_calls";
import { useAppSelector } from "../../../../../../../redux";
import { PollContent } from "../../../../../../Common";
import { usePostCardContext } from "../../PostCardContent";

export const PostPollContent = () => {
  const { postId, isWithinRepostModal } = usePostCardContext();
  const { processed_posts } = useAppSelector((state) => state.newsfeed);
  const original_post = processed_posts[postId];
  const pollData = original_post?.interactions?.poll_interaction;

  return (
    <Container>
      <PollContent
        isWithinRepostModal={isWithinRepostModal}
        onOptionClick={(optionIndex) => {
          API_CALLS.POLLS.submitAnswerForAPoll({
            choice: optionIndex,
            poll_id: pollData.id,
          });
        }}
        pollData={pollData}
      />
    </Container>
  );
};

const Container = styled.div`
  padding: ${({ theme }) => theme.spacing["spacing-2"].value}rem
    ${({ theme }) => theme.spacing["spacing-4"].value}rem;
`;
